package com.sweetlime.bingeamigo.presentation.features.search

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.sweetlime.bingeamigo.model.UserProfile
import com.sweetlime.bingeamigo.repository.AuthRepository
import com.sweetlime.bingeamigo.repository.UserRepository
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

class UserSearchViewModel(
    private val repository: UserRepository,
    private val authRepository: AuthRepository
) : ViewModel() {

    private val _users =
        MutableStateFlow<List<UserProfile>>(
            emptyList()
        )

    val users = _users.asStateFlow()

    private val _followedUserIds =
        MutableStateFlow<Set<String>>(emptySet())

    val followedUserIds = _followedUserIds.asStateFlow()

    private val _query = MutableStateFlow("")
    val query = _query.asStateFlow()

    private val _isLoading = MutableStateFlow(false)
    val isLoading = _isLoading.asStateFlow()

    fun onQueryChange(query: String) { _query.value = query }

    fun searchUsers(
        query: String
    ) {

        if (query.isBlank()) {

            _users.value = emptyList()
            _followedUserIds.value = emptySet()
            _isLoading.value = false
            return
        }

        viewModelScope.launch {

            _isLoading.value = true

            val currentUserId = authRepository.currentUserId()
            val results = repository.searchUsers(query)
                .filter { it.id != currentUserId }
            _users.value = results

            val followed = results
                .filter { repository.isFollowing(it.id) }
                .map { it.id }
                .toSet()

            _followedUserIds.value = followed
            _isLoading.value = false
        }
    }

    fun followUser(
        user: UserProfile
    ) {

        _followedUserIds.value = _followedUserIds.value + user.id

        viewModelScope.launch {

            repository.followUser(user)
        }
    }

    fun unfollowUser(
        user: UserProfile
    ) {

        _followedUserIds.value = _followedUserIds.value - user.id

        viewModelScope.launch {

            repository.unfollowUser(user.id)
        }
    }
}